import React, { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
// import ProcessedResult from "../../../download-pdf/ProcessedResult"
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import { toast } from 'react-toastify';

const CarPartsForm = ({ handleClose }) => {
    const navigate = useNavigate();
    const {
        searchedDate, selectedAudit, allAudits, auditDetails, allAuditDetailsByDate
    } = useSelector(state => state.miAuditSearchStore);

    const initialCarParts = {
        'Front Bumper': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Taillight': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Hood': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Headlight': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'TailGate': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Front Bumper': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Rear Bumper': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Bumper Grill Top': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Emblem': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Fuel Door': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Tow Hook Cover Rear': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Front PDC Sensor': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Rear Bumper Cover': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Rear Reflector Top': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Stepney': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Bumper Lip': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Front Bumper Protection Strip': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'License Plate Holder': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Fender': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Rear Tyre': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Side View Mirror': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Rear Door': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Qtr Extender': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right SideSkirts': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Pillar B': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Pillar D': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Front Wheel Rim': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Front Door Handle': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Indicator': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Stair': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Rear Door Moulding': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Right Qtr Window Glass': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Fende': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Rear Tyre': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Side View Mirror': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Rear Door': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Qtr Extender': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Sideskirts': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Pillar B': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Pillar D': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Front Wheel Rim': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Front Door Handle': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Indicator': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Rear Door Moulding': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Fog Light': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
        'Left Qtr Window Glass': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    };
   
    // const initialCarParts = {
    //     'Left_Lt_Pillar_Front(A)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Front_Door_Glass: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Rear_View_Mirror: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Front_Rim: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Lt_Front_Door: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Front_Tyre: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Fender: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Left_Lt_Pillar_Rear(C)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Left_Lt_Pillar_Center(B)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Lt_Rear_Door: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Rear_Door_Glass: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Rear_Tyre: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Lt_Qtr_Panel: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Rear_Rim: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Left_Lt_Running_Board: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Front_Bumper: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Grill: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Head_Lamp(RT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Head_Lamp(LT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Bonnet: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Indicator_Light(RT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Front_Panel: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Left_Apron: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Indicator_Light(LT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Fog_Lamp(RT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Right_Apron: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Front_Fog_Lamp(LT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Front_Door_Glass: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Rear_View_Mirror: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Right_Pillar_Front(A)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Right_Pillar_Rear(C)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Right_Pillar_Center(B)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Front_Door: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Fender: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Front_Windscreen: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Front_Rim: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Front_Tyre: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Rear_Door: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Rear_Rear_Bumper: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Rear_Tail_Lamp(LT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Rear_Dicky: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Rear_Rear_Glass: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Rear_Tyre: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Rear_Rim: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Qtr_Panel: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Door_Glass: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Right_Running_Board: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     Rear_Spare_Tyre: { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    //     'Rear_Tail_Lamp(RT)': { Intact: 0, Scratch: 0, Broken: 0, Dent: 0 },
    // };

    const [carParts, setCarParts] = useState(initialCarParts);
    const [isFormVisible, setIsFormVisible] = useState(true);
    const [frontLeftTyreNo, setFrontLeftTyreNo] = useState('');
    const [backLeftTyreNo, setBackLeftTyreNo] = useState('');
    const [backRightTyreNo, setBackRightTyreNo] = useState('');
    const [frontRightTyreNo, setFrontRightTyreNo] = useState('');
    const [chassisNo, setChassisNo] = useState('');
    const [odometer, setOdometer] = useState('');
    const [rc, setRcNo] = useState('');
    const [LicenseNo, setLicenseNo] = useState('');

    const handleChange = (part, condition, isChecked) => {
        setCarParts((prevState) => ({
            ...prevState,
            [part]: {
                ...prevState[part],
                [condition]: isChecked ? 1 : 0,
            },
        }));
    };

    const update_isAnnotated = async () => {
        try {
            const response = await axios.post("/miAuditSearch/update_annotation_flag", { audit_id: selectedAudit });
            //   console.log(response.data);
            toast.success("Annotation completed successfully!", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } catch (err) {
            console.log(err, "error");
            toast.error("Error completing annotation.", {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };
    const handleSubmit = async (event) => {
        event.preventDefault();

        console.log({
            carParts,
            frontLeftTyreNo,
            backLeftTyreNo,
            backRightTyreNo,
            frontRightTyreNo,
            chassisNo,
            odometer,
            rc,
            LicenseNo,
        });

        try {
            const response = await fetch('/miAuditSearch/submitPartDetails', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    audit_id: selectedAudit,
                    partDetails: carParts,
                    frontLeftTyreNo,     // Front Left Tyre Number
                    backLeftTyreNo,      // Back Left Tyre Number
                    backRightTyreNo,     // Back Right Tyre Number
                    frontRightTyreNo,    // Front Right Tyre Number
                    chassisNo,           // Chassis Number
                    odometer,            // Odometer Reading
                    rc,                  // RC Number
                    LicenseNo,           // License Number
                }),
            });

            if (response.ok) {
                const result = await response.json();
                // await update_isAnnotated();
                const url = `/download-pdf?audit=${selectedAudit}`;
                window.open(url, "_blank");
                // console.log('Success:', result.message);

            } else {
                console.error('Error submitting part details');
            }

            setIsFormVisible(false);
            handleClose();

        } catch (error) {
            console.error('Error:', error);
        }
    };


    const inputStyle = {
        padding: "0.5rem",
        borderRadius: "4px",
        border: "1px solid #ddd",
        width: "100%",
        marginBottom: "1rem"
    };

    return (
        <>
            {isFormVisible && (
                <form
                    onSubmit={handleSubmit}
                    style={{
                        backgroundColor: "#f7f7f7",
                        padding: "2rem",
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                        maxWidth: "600px",
                        margin: "0 auto"
                    }}
                >
                    {Object.keys(carParts).map((part) => (
                        <div
                            key={part}
                            style={{
                                marginBottom: "1.5rem",
                                padding: "1rem",
                                border: "1px solid #ddd",
                                borderRadius: "5px",
                                backgroundColor: "#fff"
                            }}
                        >
                            <h3 style={{ marginBottom: "1rem", color: "#333" }}>{part}</h3>
                            <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                                {Object.keys(carParts[part]).map((condition) => (
                                    <label
                                        key={condition}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            backgroundColor: "#fafafa",
                                            padding: "0.5rem",
                                            borderRadius: "4px",
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)"
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={carParts[part][condition] === 1}
                                            onChange={(e) => handleChange(part, condition, e.target.checked)}
                                            style={{ marginRight: "0.5rem" }}
                                        />
                                        {condition}
                                    </label>
                                ))}
                            </div>
                        </div>
                    ))}

                    {/* New fields for Tyre Numbers, Chassis Number, Odometer, RC, License No */}
                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Front Left Tyre No:</label>
                        <input
                            type="text"
                            value={frontLeftTyreNo}
                            onChange={(e) => setFrontLeftTyreNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Back Left Tyre No:</label>
                        <input
                            type="text"
                            value={backLeftTyreNo}
                            onChange={(e) => setBackLeftTyreNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Back Right Tyre No:</label>
                        <input
                            type="text"
                            value={backRightTyreNo}
                            onChange={(e) => setBackRightTyreNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Front Right Tyre No:</label>
                        <input
                            type="text"
                            value={frontRightTyreNo}
                            onChange={(e) => setFrontRightTyreNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Chassis No:</label>
                        <input
                            type="text"
                            value={chassisNo}
                            onChange={(e) => setChassisNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>Odometer:</label>
                        <input
                            type="number"
                            value={odometer}
                            onChange={(e) => setOdometer(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>RC No:</label>
                        <input
                            type="text"
                            value={rc}
                            onChange={(e) => setRcNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                        <label>License No:</label>
                        <input
                            type="text"
                            value={LicenseNo}
                            onChange={(e) => setLicenseNo(e.target.value)}
                            style={inputStyle}
                        />
                    </div>

                    <button
                        type="submit"
                        style={{
                            backgroundColor: "#007BFF",
                            color: "#fff",
                            padding: "0.8rem 1.5rem",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "1rem",
                            transition: "background-color 0.3s"
                        }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#007BFF"}
                    >
                        Submit
                    </button>
                </form>
            )}
        </>
    );

};

export default CarPartsForm;
